/* eslint-disable  no-lonely-if  */
import React, { FC, useMemo } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { isEmpty } from 'lodash';
import Form from '~/components/WizardForm';
import Section from '~/layouts/Section ';
import { useGetApplication } from '~/controllers/wizard';
import CustomFields from '~/components/CustomFields';
import theme from '~/constants/theme';
import CompanyInformationInputs from './CompanyInformationInputs';
import AnnualTurnoverInputs from './AnnualTurnoverInputs';
import SanctionsQuestionsInputs from './SanctionsQuestionsInputs';
import FatcaCrsSelfDeclarationation from './FatcaCrsSelfDeclarationation';
import PepInputs from './PepInputs';
import PepCategories from './PepCategories';

const Questionnaire: FC = () => {
  const { t } = useTranslation('fillApplication');

  const applicationQuery = useGetApplication();

  const hasPep = useMemo(() => {
    const payload = applicationQuery.data?.payload;
    if (!isEmpty(payload?.authorizedRepresentative) && payload?.authorizedRepresentative?.find((item) => item.isPep)) {
      return true;
    }
    if (payload?.shareholders?.individuals?.find((item) => item.data.isPep)) {
      return true;
    }
    if (payload?.shareholders?.beneficialOwners?.find((item) => item.data.isPep)) {
      return true;
    }
    return false;
  }, [applicationQuery.data]);
  const hasEcom = useMemo(() => {
    const payload = applicationQuery.data?.payload;
    return !!payload?.services?.eCommerce?.enabled;
  }, [applicationQuery.data]);

  const showPepSection = !hasPep;

  const [form] = Form.useForm();

  return (
    <Container className="Questionnaire">
      <Form
        onValuesChange={() => {
          const annualExpectedValue = form.getFieldValue([
            'additionalInformation',
            'companyInformation',
            'annualTurnover',
          ]);
          const stringifiedValue = String(annualExpectedValue);
          if (stringifiedValue.includes('.')) {
            const splitedValue = stringifiedValue.split('.');
            if (splitedValue[0]?.length > 16) {
              form.setFieldValue(
                ['additionalInformation', 'companyInformation', 'annualTurnover'],
                `${splitedValue}.${splitedValue[1]}`,
              );
            }
          } else {
            if (stringifiedValue?.length > 16) {
              form.setFieldValue(
                ['additionalInformation', 'companyInformation', 'annualTurnover'],
                `${stringifiedValue.substring(0, 16)}.00`,
              );
            }
          }
        }}
        form={form}
        stepKey="additionalInformation"
      >
        <Section formItemLast>
          <Typography.Title level={4}>{t('Business Details').toUpperCase()}</Typography.Title>
          <CompanyInformationInputs hasEcom={hasEcom} />
        </Section>
        {/* <Section>
          <Typography.Title level={4}>{t('Annual turnover / expected annual turnover').toUpperCase()}</Typography.Title>
          <AnnualTurnoverInputs />
        </Section> */}

        <section>
          <Typography.Title level={4}>{t('Company questionnaire').toUpperCase()}</Typography.Title>
          <Typography.Title level={5}>
            {t('Do you hold any position from the below list of categories?')}
          </Typography.Title>
          <Typography.Paragraph>
            {t(
              '***Individuals or international entities who are or have been entrusted with prominent public functions and their immediate family members and close associates.',
            )}
          </Typography.Paragraph>
          <PepCategories />
          <PepInputs form={form} />
        </section>

        <Section>
          <SanctionsQuestionsInputs form={form} />
        </Section>
        <Section>
          <Typography.Title level={4}>{t('Fatca/crs self - declarationation').toUpperCase()}</Typography.Title>
          <FatcaCrsSelfDeclarationation form={form} />
        </Section>
        <CustomFields />
      </Form>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 48px;
  @media (max-width: ${theme.breakpoints.md}px) {
    margin-top: 24px;
  }
`;

export default Questionnaire;
